// src/components/CookieBanner.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import CookieConsent from 'react-cookie-consent';

function CookieBanner() {
  const { t } = useTranslation();

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookies.accept')}
      declineButtonText={t('cookies.decline')}
      cookieName="moricomeCookieConsent"
      style={{ 
        background: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '20px',
        alignItems: 'center',
        fontSize: '14px',
        zIndex: 9999
      }}
      buttonStyle={{ 
        background: '#4CAF50',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        borderRadius: '6px',
        padding: '10px 24px',
        margin: '0 10px'
      }}
      declineButtonStyle={{
        background: 'transparent',
        border: '2px solid #fff',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        borderRadius: '6px',
        padding: '8px 24px'
      }}
      expires={150}
      enableDeclineButton
      onAccept={() => {
        console.log('✅ Cookies accepterade');
        // GA är redan aktivt
      }}
      onDecline={() => {
        console.log('❌ Cookies avböjda - stänger av GA');
        // Stäng av Google Analytics
        window['ga-disable-G-E97ZYKERBK'] = true;
        
        // Ta bort GA cookies
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
      }}
    >
      {t('cookies.message')}{' '}
      <a 
        href="/privacy" 
        style={{ 
          color: '#4CAF50', 
          textDecoration: 'underline',
          fontWeight: '600'
        }}
      >
        {t('cookies.learnMore')}
      </a>
    </CookieConsent>
  );
}

export default CookieBanner;
